import {useTranslation} from 'react-i18next'
import {PhotoUploadField} from '@/components/photo-upload-field'
import {useUploadMyControlFoto} from '@/hooks/sgsst/riesgos/use-entrevista'

/** v3.9 spec A5: same direct-to-storage flow as `HallazgoFotoUpload`, scoped to `mi/controles/{id}`. */
export function ControlFotoUpload({
  businessId,
  controlId,
  hint,
  onUploaded,
}: {
  businessId: string
  controlId: string
  hint: string
  onUploaded?: () => void
}) {
  const {t} = useTranslation()
  const upload = useUploadMyControlFoto(businessId)

  return (
    <PhotoUploadField
      testId={`control-foto-${controlId}`}
      inputTestId="control-foto-input"
      buttonTestId="control-foto-upload"
      buttonLabel={t('entrevista.foto.action', {hint})}
      onUpload={(file, onProgress) => upload.mutateAsync({controlId, file, onProgress})}
      onUploaded={onUploaded}
    />
  )
}
